import request from '@/sheep/request';

const AccountApi = {
  // 获取账号状态（0=停用，1=启用）
  getAccountStatus: () => {
    return request({
      url: '/operation/thirdparty/moca/app/account/status',
      method: 'GET',
      custom: {
        showLoading: false,
        showError: true,
        auth: false,
      },
    });
  },
};

export default AccountApi;
